import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import axios from 'axios';
import authService from './api-authorization/AuthorizeService';

interface TaskList {
    tasks: Task[];
    loading: boolean;
}

interface Task {
    id: number;
    type: string;
    assignedTo: string;
    dueDateFormatted: string;
    siteAddress: string;
    linkTo: string;
}

export class TaskData extends React.Component<RouteComponentProps<{}>, TaskList> {
    constructor(props: any) {
        super(props);
        this.state = { tasks: [], loading: true };
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/Tasks/GetTasks?SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ tasks: res.data, loading: false });
        })
    }

    public render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            <h1>Tasks</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var tasks = this.state.tasks;

        return (
            <div className='overflowAuto'>
                <table className='table tableColours tableColours'>
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Site Address</th>
                            <th>Due Date</th>
                            <th>Assigned To</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {tasks.map(task =>
                            <tr key={task.id}>
                                <td>{task.type}</td>
                                <td>{task.siteAddress}</td>
                                <td>{task.dueDateFormatted}</td>
                                <td>{task.assignedTo}</td>
                                <td>
                                    <Link to={task.linkTo + task.id}>
                                        Run
                                    </Link>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    }
}


